import { ShoppingCartDiscount } from 'src/app/models/shopping-cart/shopping-cart-discount';

export class Discount extends ShoppingCartDiscount {}
